import { _ as __assign } from './_tslib-3301712a.js';

/** Утилита по работе с postMessage интерфейсом. */
var PostMessage = {
    /** Слушает postMessage сообщения */
    on: function (passedOptions) {
        var defaultOptions = { origin: window.location.origin };
        var options = __assign(__assign({}, defaultOptions), passedOptions);
        var listener = function (event) {
            if (event.origin !== options.origin) {
                return;
            }
            var data;
            try {
                data = JSON.parse(event.data);
            }
            catch (_) {
                return;
            }
            if (data && options.handlers[data.name] instanceof Function) {
                options.handlers[data.name](data.data, event);
            }
        };
        window.addEventListener('message', listener);
        return function () {
            window.removeEventListener('message', listener);
        };
    },
    /** Отсылает postMessage сообщение */
    trigger: function (options) {
        options.target.postMessage(JSON.stringify(options.message), options.origin || '*');
    },
};

export { PostMessage as P };
//# sourceMappingURL=postMessage-9d8eba93.js.map
